export default  {
  "interview_shindo": {
    "first": {
      "name": "T・Sさん",
      "year": "2012年入社",
      "career": "中途入社",
      "job": "常務取締役・Webエンジニア・マネージャー",
      "title": "新しいことに挑戦できる環境がある",
      "visual": "shindo_main",
      "subtitle": "「Web」は「現実」の投影",
      "text": "私が入社したのは10年以上前になるのですが、その頃はまだ「Webサイト」は情報を一方的に発信するだけのイメージでした。<br />その頃から弊社社長は「Web」は「現実」の投影ということを考えており、Webの可能性を誰よりも信じていました。<br />そのことに感銘を受け、エンジニアとして一緒にその可能性に挑戦したいと思い入社しました。<br />現在、コロナウイルスの流行もあり、DXという観点からも「Web」の重要性が増してきていることが明らかで、まさに「現実」と同じように購買や営業的なコミュニケーションを「Web」を通じて行える時代になってきたからこそ、当時社長が言っていた「Web」は「現実」の投影ということを実感しております。"
    },
    "second": {
      "visual": "shindo_sub",
      "subtitle": "自分の成長とともに会社も成長",
      "text": "私が入社したころはエンジニアは2,3人という小さい組織でしたが、今では50人を超える規模にもなってきています。そのため、私の立場もメンバーからチームリーダー（現チーフ）になり、チームが複数できたことでマネージャーと昇格していきました。<br />現在もプレイングマネージャーとして案件を進めながらメンバーのマネジメントに努めていますが、常に新しいことへの挑戦があります。<br /><br />入社当初の案件はCMSを利用したWebサイトの構築がメインでしたが、現在はCMSと基幹システム（CRMや認証基盤など）との連携であったり、会員サイトやECサイトなどの構築を手掛けています。<br />技術的な提案、見積もり、アーキテクチャ設計、技術的な方針の決定、メンバー管理などが自分の役割だと感じています。<br /><br />また、組織としては技術的な方針の決定、メンバー配置（アサイン）、評価も担っています。"
    },
    "third": {
      "visual": "shindo_sub2",
      "subtitle": "伸びしろがある会社",
      "text": "率直な感想としては、働きやすい会社だと思います。<br />しっかりメンバーの声を聞いて改善しようという雰囲気があり、情報共有の重要性をみんなが理解して実行できていると感じています。<br /><br />ただ、もっと利益を上げていくためには会社全体のレベルを上げていかないといけないとも感じていますが、逆に言うと今後成長していける伸びしろがある会社だと思います。"
    },
    "remote": {
      "text": "始業前や休憩中に、家のことができるのは助かります。<br />客先に向かう頻度が減ったぶん、連続でオンライン会議に出席することが増えたので、自分の時間があまり取れなくなるときもあります。"
    },
    "flow": {
      "time_1": "8:50","text_1": "メールのチェックや一日のスケジュールの再確認",
      "time_2": "9:00","text_2": "いくつかの案件の技術支援のための打ち合わせや定例会の参加",
      "time_3": "12:00","text_3": "昼食",
      "time_4": "13:00","text_4": "案件の課題やタスクを行う",
      "time_5": "15:00","text_5": "チーフとの打ち合わせ",
      "time_6": "16:00","text_6": "採用面談やアサインの検討など",
      "time_7": "19:00","text_7": "終業"
    },
    "point": {
      "visual": "shindo_sub02",
      "text": "Sitecore Technical MVP 2016受賞<br />Sitecore Technical MVP 2017受賞<br />Sitecore Technical MVP 2018受賞<br />Sitecore Technical MVP 2019受賞<br />Sitecore Technical MVP 2020受賞"
    },
  },

  "interview_takada": {
    "first": {
      "name": "C・Tさん",
      "year": "2012年入社",
      "career": "中途入社",
      "job": "経営企画室・チーフ",
      "title": "仕事と家庭を両立しながら活躍できる場がある",
      "visual": "takada_main",
      "subtitle": "希望とマッチした内容に魅かれて入社",
      "text": "私が求人を見つけた時は、20人程度の小さな会社でした。<br />その頃はまだ幼い子供がいたので、短い時間で勤務出来てかつ興味を持てそうなお仕事を探していたのですが、15時までの勤務でOKという事と、当時社長が一人で行っていたバックヤード業務やデータ入力など幅広い業務をお手伝い出来るという内容にも興味を持って入社しました。<br />入社してからも、仕事と子育ての両立をスムーズに受け入れてくれる社長と従業員の皆様に支えられたおかげで、長く勤務出来ていると感謝しています。"
    },
    "second": {
      "visual": "takada_sub",
      "subtitle": "会社の成長を見続けた10年間",
      "text": "事務職の経験は全くないものの、勤務経験は11年程ありましたので自分のスキルを活かしつつ、忙しい社長の業務負担を軽減するためにも総務・労務・経理・人事その他様々な業務をお手伝いしながら少しずつ引き取っていくという状況でした。<br />その間にオフィスの移転もあり細かい手続きや段取りなど、意外と知らない事が多く勉強になりました。<br /><br />数年経った頃には、勤務時間も少し伸ばすことができ、より多くの仕事をこなせるようにはなりましたが、バックヤード業務は範囲が広い上にそれぞれが奥深く、やはり一人ではどれも中途半端になるのが申し訳ないと感じていました。<br /><br />会社の成長と共に社員数も年々増していく中で、2017年にいよいよ「経営企画室」という部署を立ち上げる事になりました。毎年1名ずつ新卒社員が加わって部署らしくなっていく頃、私自身もフルタイムで勤務出来る状況になり、メンバーとも役割分担をする事で、私は労務や請求管理などとても重要な業務を本格的に取り組むことが出来るようになりました。<br />現在はチーフとして、若いメンバー達のマネジメントや自身の業務に日々奮闘しつつ、社長直属の部署として経営戦略に関わる重要な管理業務なども行うようになり、やりがいを感じています。<br /><br />経営企画室は会社にとっても従業員にとっても「縁の下の力持ち」だと思っています。<br />元々業務の幅が広く量も多いので、会社の成長や従業員の増加に伴って業務も増える一方ですが、そこをいかに効率よくするかを考えながら、従業員にとって働きやすい会社づくりをしていくかが重要になってきます。<br />フロント業務とは違った観点で、いつも頼れる存在の経営企画室でありたいと考えています。"
    },
    "third": {
      "visual": "takada_sub2",
      "subtitle": "みんなで作る会社",
      "text": "入社当時は20名程度の会社が、現在は110名以上という会社に成長しました。<br />規程以外のルールがまだあまり確立していないような状況から、社員が増える毎に意見を出し合って少しずつ今の形になってきていると感じます。<br />それは会社全体が風通しよく、社員の意見を吸い上げ、柔軟に対応出来る会社だからだと思っています。<br /><br />とは言え、まだまだ未熟で整備されていない部分も多いですので、これからも変化を楽しみつつ、より良い会社へと成長していく過程を楽しみにしたいです。"
    },
    "remote": {
      "text": "平日しかできない用事などを休憩時間を使って行う事ができます。<br />通勤時間がないので、退勤後にプライベートの用事を入れやすいことも魅力です。<br />自宅で集中して作業出来るという点ではいいですが、何かを相談したい時に相手の様子（忙しいかどうか）が分からないので気を使ってしまうこともあります。"
    },
    "flow": {
      "time_1": "8:40","text_1": "Slackやメールチェック、朝会",
      "time_2": "9:30","text_2": "勤怠・作業報告確認、労務関連タスク（手続き、規程、月初は給与計算など）",
      "time_3": "12:30","text_3": "ランチ",
      "time_4": "13:30","text_4": "請求案件の確認・一覧更新、毎月の請求額精査",
      "time_5": "15:00","text_5": "資料作成、フローの見直しなど",
      "time_6": "17:00","text_6": "MTG資料準備、議事録確認",
      "time_7": "18:00","text_7": "作業報告、明日のタスク確認、業務終了"
    },
  },

  "interview_maehara": {
    "first": {
      "name": "D・Mさん",
      "year": "2017年入社",
      "career": "中途入社",
      "job": "Webディレクター・マネージャー",
      "title": "理想的な制作環境と高度な技術力が強み",
      "visual": "maehara_main",
      "subtitle": "制作会社として理想的な環境が整っていると感じた",
      "text": "デザイナーとエンジニアが内製メンバーで揃っているので、コミュニケーションが取りやすいだろうなと感じました。<br />LYZONでは、一般的にはディレクターが担う大量のコンテンツの入れ込みやチェック作業を「サポートデスク」という部署が一括で担当していることを知り、理想的な体制だと思いました。<br />また、Web制作やシステム構築における高い技術力があると感じて入社を決めました。"
    },
    "second": {
      "visual": "maehara_sub",
      "subtitle": "現場で高度な制作経験を積み、マネージャーに就任",
      "text": "入社1年目に、比較的小規模な構築案件を経験した後、大手不動産会社グループサイト統合、CRM連携構築という前職では経験したことのない大規模で高度なプロジェクトにアサインされました。<br />未経験の技術領域もあり苦労しましたが無事スケジュール通りリリースすることができました。<br /><br />その後、他のメンバーにディレクション、プロジェクトマネジメントノウハウを指導する立場としてマネージャーに就任しました。<br />現在はチームの人数も増え、メンバーの個々のマネジメントはチーフに任せる体制となり組織全体のパフォーマンスを向上させる立場として取り組んでいます。<br /><br />LYZONのディレクターは、クライアントと技術者メンバーの間に立って要件を整理、問題を紐解いて推進することが役目だと思っています。<br />現在は、マネージャーとしてディレクターメンバーの成長の機会を最大化し、組織の力を高めることを意識しています。"
    },
    "third": {
      "visual": "maehara_sub2",
      "subtitle": "自分たちの考えたことが即実行できる",
      "text": "こうしたいと思ったことは即時実行できる反面、主体的に考えることができないと何も進めることができない可能性があります。<br /><br />社長を始めとして会社は新しい意見について耳を傾け、良いアイディアは即実行してみるという企業風土があり、働きやすさにつながっていると思います。<br /><br />受け身のスタンスではなく、自分からアイデアを出せる方を求めています。"
    },
    "remote": {
      "text": "勤務開始前に洗濯もの干しなどの家事を済ませることもでき、ランチは自炊してから食べる機会も増えて以前よりも料理が上手になりました。<br />リモートの場合は直接顔を合わせて雑談や作業の様子を見ることができない分、日々のリモートMTGをうまく行うことが重要です。"
    },
    "flow": {
      "time_1": "9:00","text_1": "Slack・メールチェック",
      "time_2": "9:30","text_2": "今日のタスク整理",
      "time_3": "10:00","text_3": "プロジェクトメンバー朝会",
      "time_4": "13:00","text_4": "お昼休憩",
      "time_5": "14:00","text_5": "クライアント打ち合わせ",
      "time_6": "16:00","text_6": "資料作成",
      "time_7": "18:30","text_7": "作業報告、退勤"
    },
  },

  "interview_kim": {
    "first": {
      "name": "H・Kさん",
      "year": "2017年入社",
      "career": "新卒入社",
      "job": "Webデザイナー・チーフ",
      "title": "マルチに活躍できるデザイナーとしてスキルアップできる",
      "visual": "kim_main",
      "subtitle": "デザインとコーディングができる環境",
      "text": "デザインだけではなくコーディングの仕事にも携わりたいと考えており、LYZONのデザイナーは「デザイン」と「コーディング」両方を行うことができるため、入社を決めました。"
    },
    "second": {
      "visual": "kim_sub",
      "subtitle": "自ら学ぶ姿勢を持つことで成長できたと実感",
      "text": "入社後1年間はLYZONのデザイナーに必要なスキルや社内ツールをしっかり勉強します。<br />また簡単な運用タスクも並行で担当するため、社内の他部署との連携や仕事の流れなどがわかり、仕事に慣れやすい環境でした。2,3年目からは小規模の構築案件を担当しました。デザインからコーディングまで一人で担当し、プロジェクトの全般的な流れを把握しながら仕事をすることができました。<br /><br />4年目には会社のニーズを把握し、必要なスキルを勉強したり、実際に会社に貢献することができました。<br />5年目からはチーフになり、プレイヤーの立場より、人材を育てるマネジメントに力を入れています。<br /><br />LYZONのデザイナーはデザインとコーディングの両方を担当しているので、他部署より求められるスキルが多いかもしれません。どちらか片方だけでも勉強することがたくさんあると思います。<br />またこの職種は新しいスキルや流行の入れ替りが激しいので、常に勉強していないと遅れてしまいます。<br />積極的に自分から勉強して新しいスキルを吸収することが大事だと思います。<br />LYZONのデザイナーでも定期的にスキルを共有する場も設けているので、お互いに刺激を受け、成長できる機会が整っています。"
    },
    "third": {
      "visual": "kim_sub2",
      "subtitle": "働きやすくスキルアップできる環境",
      "text": "デザイナーと聞くと、修正が多く残業も多いイメージがありますが、LYZONのデザイナーは違いました。<br />来週のタスクを事前に工数化して決めることで、当日にいきなり作業が発生することはほとんどありません。<br /><br />LYZONのデザイナーはデザインとコーディング両方に携わるので、コーディングを考えたデザインをしたり、社内のエンジニアと直接連携することで、モジュール化やコンポーネント化することを考えられたコーディングができます。<br />それによってプロジェクトに関する視野が広がり、他部署との連携もスームズに対応することができます。"
    },
    "remote": {
      "text": "満員電車や通勤時間の負担がなくなって良いです。<br />プライベート空間なので、周りの目を気にせず仕事に集中できたり、休憩時間を家のことに使うことができます。平日でも荷物を受け取ることができるのもいいです。<br />オンラインミーティングはカメラやマイクのオン・オフにより相手のリアクションが分かりづらいこともあるのが課題です。"
    },
    "flow": {
      "time_1": "10:00","text_1": "朝会（チームメンバーとリモートで雑談）",
      "time_2": "10:30","text_2": "メールとSlackと本日のタスクを確認",
      "time_3": "11:00","text_3": "案件のサイトデザインを制作",
      "time_4": "13:00","text_4": "ランチ",
      "time_5": "14:00","text_5": "プロジェクトメンバーとミーティング",
      "time_6": "15:00","text_6": "案件のサイトコーディング",
      "time_7": "19:00","text_7": "退勤"
    },
  },

  "interview_yamaguchi": {
    "first": {
      "name": "T・Yさん",
      "year": "2021年入社",
      "career": "中途入社",
      "job": "Webエンジニア",
      "title": "自分のノウハウを後輩へ伝授するのが役目",
      "visual": "yamaguchi_main",
      "subtitle": "分野のプロフェッショナルを目指すため",
      "text": "以前は、SESとしていろんな会社を渡り歩いていました。そのおかげで技術の幅は広がってきたのですが専門的な技術に乏しいために自分の評価が低く見られることが多くなってきました。<br />そのために、同じ作業のできる正社員になることで技術に集中して学んでいくことでプロフェッショナルを目指したいと考えて入社を決めました。"
    },
    "second": {
      "visual": "yamaguchi_sub",
      "subtitle": "大規模案件を担当しました",
      "text": "あるメーカーの製品管理システムの構築を担当しました。仕様書や実装、テスト等の作業をしました。作業内容としては以前にも行っている作業なので大きな問題がなく作業を進められた感じです。<br />その後も案件内のコア部分である、ユーザーからは見えない部分を対応しています。<br /><br />自分の経験年数で言うとシステム開発を進めることができるのは前提になっています。なので、それ以上の役割として後輩の育成があるのではないかと考えています。<br />LYZONは基本若い人や新人が多いので自分の技術を伝えたり、業務としての立ち回りを伝えていくのが重要だと思っています。"
    },
    "third": {
      "visual": "yamaguchi_sub2",
      "subtitle": "自由度の高さに驚きました",
      "text": "いろんな会社へ行ってきましたが、LYZONの自由度の高さに驚きました。<br />リモートワークもまだ続いているので、出勤時間を別の時間に割り当てられるので働きやすいです。<br />だけど、成果も求められるのでより良い実績を残せるかが課題なのかと思います。"
    },
    "remote": {
      "text": "通勤時間が無くなるので自由時間が増えました。<br />しかし通勤もいい運動だったのか、体力の落ちが最近気になるので適度なバランスが必要なのかなと思います。"
    },
    "flow": {
      "time_1": "10:00","text_1": "業務開始<br />朝会",
      "time_2": "10:30","text_2": "A案件 詳細仕様書作成",
      "time_3": "13:00","text_3": "ランチ",
      "time_4": "14:00","text_4": "B案件 ソースコード作成",
      "time_5": "15:00","text_5": "チームMTG",
      "time_6": "17:00","text_6": "B案件 テスト実施",
      "time_7": "19:00","text_7": "業務作業履歴作成<br />業務終了"
    },
  },

  "interview_tanuma": {
    "first": {
      "name": "K・Tさん",
      "year": "2008年入社",
      "career": "新卒入社",
      "job": "取締役・企画提案営業・マネージャー",
      "title": "お客様が抱えるさまざまな課題を解決できる提案を",
      "visual": "tanuma_main",
      "subtitle": "ユーザーに貢献できる仕事をしたかった",
      "text": "当時、LYZONは病院・クリニック向けWebサイト制作を中心に事業展開していたのですが、「病院やクリニックのWebサイトであれば、ユーザーである患者様が利用しやすいWebサイトを作ることで社会貢献できるはず」と考え応募し、採用されました。<br /><br />実際には、現在の主力である企業向けWebサイト制作事業の立ち上げから参画することになりましたが、「各クライアント様のお客様やパートナー様が利用しやすいWebサイト・Webシステムを構築する」という意味では当初やりたいことを別の形で実現できたと思っています。"
    },
    "second": {
      "visual": "tanuma_sub",
      "subtitle": "LYZONで得た知見を活かして、現在はマネージャー職に従事しています",
      "text": "入社後約9年間はWebディレクターとして、LYZONで当時の最大規模プロジェクトのディレクターを多数務めてきました。<br />入社初期は300万円ほどのプロジェクトでもお客様とのコミュニケーションからスケジュール管理、開発メンバーとの調整、CMSへのコンテンツ入れ込み作業、テスト・チェック作業まで、多岐に亘る業務に振り回されながら取り組みました。<br />その後、プロジェクト規模も1,000万円規模～数千万円規模と拡大していく中で、ディレクション工程が複雑化しそれまで直面しなかった未知の課題・トラブル対応に奮闘しました。<br /><br />入社10年目からは新設された営業部署でプレイングマネージャーを務めています。（※現在、弊社ではジョブチェンジ制度を導入しておりません。）<br />法人向け企画提案営業職としてヒアリングから見積・提案書作成、受注へのクロージング対応までをこなす傍ら、人事・採用、営業業務の改善施策立案・実行、案件・売上管理等のマネジメント業務、また、ディレクター時代の経験を活かしトラブルシューティング対応も一部こなしています。<br /><br />LYZON営業マンの役割の特徴として、幅広いカバー領域が挙げられます。企画提案営業業務はもちろん、ビジネスパートナーへの提携・協業対応、イベント・セミナー（ウェビナー）運営支援、自社メディア運営支援、商材開発・改善対応等、全員が全領域に携わることは稀ですが、メンバーに応じて複数の業務領域に取り組んでいます。"
    },
    "third": {
      "visual": "tanuma_sub2",
      "subtitle": "常に新鮮な仕事に携わりたいです",
      "text": "おかげさまでディレクターとして大規模Webサイトのディレクションもひと通り理解し、それを活かした企画提案営業においてもお客様が抱えるさまざまな課題を解決させる提案を自信をもって提示できるようになりました。しかし一方で、提案数が増えてくるとある程度パターン化されるサイクルに陥りがちになり、思考が滞りがちになるのを感じることがあります。<br /><br />現在は営業部署の人数が他部署より少なく若手社員が多いこともあり、自身の業務量が非常に多いのでそれらをうまく分散化させた上で、これからはもっとコンセプトを意識した提案やマネジメント改善施策の取り組みを推進していきたいです。"
    },
    "remote": {
      "text": "リモートワークはリラックスして業務できるので、腰を据えて提案書のコンセプトを考えたり重要なマネジメント業務を行うのに適していると考えます。<br />ただ、個人的には「自宅はプライベート」の意識がまだ強い為、タスクをまとめて集中して一気に捌きたい時等にはオフィスワークの方が適していると考えているので、仕事内容に応じた使い方が出来ると良いと思います。"
    },
    "flow": {
      "time_1": "9:00","text_1": "営業ユニットで朝会",
      "time_2": "9:30","text_2": "メール・Slackチェック",
      "time_3": "10:00","text_3": "お客様とMTG",
      "time_4": "12:00","text_4": "ランチ",
      "time_5": "13:00","text_5": "マネジメント業務",
      "time_6": "16:00","text_6": "見積・提案書作成",
      "time_7": "20:30","text_7": "翌日のスケジュールとタスク管理を済ませ、業務終了"
    },
  },

  "interview_kobayashi": {
    "first": {
      "name": "D・Kさん",
      "year": "2014年入社",
      "career": "新卒入社",
      "job": "Webディレクター・マネージャー",
      "title": "自分の意見が言える会社という色を大事にしていきたい",
      "visual": "kobayashi_main",
      "subtitle": "会社と共に成長できる環境で働きたかった",
      "text": "私が入社した頃は社員20～30名程度の小さい会社でした。<br />ある程度完成された会社、というよりは共に成長できる環境に身を置きたかったこと、また裁量を持って仕事をしたかったため、会社の社風や規模に魅力を感じ入社を決めました。<br />また大手企業様向けの商材であることも、自分の経験としてはメリットになると考えていました。"
    },
    "second": {
      "visual": "kobayashi_sub",
      "subtitle": "現場で経験を積み現在はマネージャーとして活動",
      "text": "入社1年目は小規模案件のメインディレクターと大規模プロジェクトのサブディレクターを兼任し、プロジェクトの進め方や細かいディレクション業務を学びました。<br />入社3年目には比較的大きなプロジェクトのプロジェクトマネジメントを経験し、その中でプロジェクトにおける様々なリスクや課題に直面し、当時は苦労しながら進めていました。<br />5年目にはディレクターチーフに就任し、ディレクターメンバーと直接コミュニケーションを取りながらマネジメントを行い、その後ディレクターマネージャーとして、組織の改善や各プロジェクトおけるパフォーマンス向上を目指して活動しています。"
    },
    "third": {
      "visual": "kobayashi_sub2",
      "subtitle": "率直な意見を言い合える会社",
      "text": "入社当初は人数も少なかったこともあり、お互いの距離感も近く、率直な意見を言い合っているなと感じました。例えば社長の意見に対して、1メンバーが堂々と反対意見を述べているところも見て、最初は驚きを感じましたが、お互いにより良いものを目指してフラットに議論をしているのだと、後になって理解しました。<br />今は社員数も多くなり、当初ほどの社員同士の距離感ではないと思いますが、率直に自分の意見が言える会社、という色は大事にしていきたい部分だなと感じています。"
    },
    "remote": {
      "text": "夫婦共働きのため、子どもが熱を出して保育園を休むことになった場合、リモートであれば妻と分担しながら子どもの様子を見ることもできるので助かっています。<br />一方で社内の問題について検知が一歩遅れてしまうケースがあるため、状況についてはより注意して見ていく必要があると感じています。"
    },
    "flow": {
      "time_1": "9:00","text_1": "Slack・メールチェック",
      "time_2": "9:30","text_2": "1on1面談",
      "time_3": "11:00","text_3": "お客様とMTG",
      "time_4": "12:00","text_4": "ランチ",
      "time_5": "13:00","text_5": "社内定例・資料作成",
      "time_6": "16:00","text_6": "リソース調整・社内MTG",
      "time_7": "18:30","text_7": "作業報告・退勤"
    },
  },
  "interview_uemura": {
    "first": {
      "name": "R・Uさん",
      "year": "2018年入社",
      "career": "中途入社",
      "job": "Webディレクター・チーフ",
      "title": "当たり前のことが大切にされている会社",
      "visual": "uemura_main",
      "subtitle": "自分も営業戦略に加わりたいと思った",
      "text": "当時の私はSitecoreを扱ったことがなく、どういうものかはWebで見た程度でした。LYZONはSitecore国内実績No.1を掲げており、お客様には有名企業様が名を連ねておりました。社内では何か特化して1番になるための戦略に、また、対お客様においては、営業戦略に自分も加わりたいと思ったため、入社を決めました。"
    },
    "second": {
      "visual": "uemura_sub",
      "subtitle": "挑戦したかった仕事に携わることができた",
      "text": "私の場合は、入社後すぐに担当のクライアントが決まりました。<br />前職ではやりたくてもできなかった「より良くする」たぐいの業務を担当し、クライアントの会社に訪問して、ウェブサイトの改善提案をし、どういう形が理想なのかをクライアントと話し合いを重ねました。<br />別のクライアントはSitecoreのバージョンアップをするタイミングだったので、その提案から入り、受注、追加修正を含めた新バージョンでの構築業務を、経験することができました。"
    },
    "third": {
      "visual": "uemura_sub2",
      "subtitle": "転職して良かったと思えた",
      "text": "前職ではWordPressを使った小さなサイトの制作を行っており、いかに手離れよく工数をかけずに多くのサイトを作るかということが重視されていました。<br />内容を充実させることやお客様の満足度を高めて、次につなげるというよりは、その1回だけをなんとかやり切り、当月中に検収できることが目標でした。<br />ですが、LYZONでは、ひとつのサイトをつくるにあたり、お客様の事業内容をよく知って提案すること、お客様に納得していただいたり満足していただくという、当たり前のことが大切にされていて、転職して良かったと感じています。"
    },
    "remote": {
      "text": "主婦でもあるので、出社する日は家を出る7時半までに、洗濯+朝ごはん・子どものお弁当・夕飯をすべて用意しなければならないですが、リモートだと夕飯は21時までに作るか、もしくは昼休憩時に作ることもできるので、とても楽です。また、子どもが学校から帰って来た時に私が家にいるので、子どもの満足度も高いです。"
    },
    "flow": {
      "time_1": "9:00","text_1": "朝会・タスク整理",
      "time_2": "9:30","text_2": "プロジェクト進捗管理",
      "time_3": "11:00","text_3": "資料作成",
      "time_4": "13:00","text_4": "ランチ",
      "time_5": "14:00","text_5": "クライアント打ち合わせ・メンバーフォロー",
      "time_6": "17:30","text_6": "プロジェクト進捗管理",
      "time_7": "18:30","text_7": "作業報告・退勤"
    },
  }
}


// WEBPACK FOOTER //
// ./src/json/interviews.js